import styles from './style.scss';

import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';

import {FlywheelComponent} from '#lit/lib/component.js';
import {
  ImmutableComponent,
  modelGetter,
  modelSetter,
} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';

import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';

export const COMPONENT_TAG = 'fly-surface-list-item';

const propSetter = modelSetter<Msg>();

@customElement(COMPONENT_TAG)
export class FlyFloatingSurfaceItem extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  static get styles() {
    return [styles];
  }

  @property({type: Boolean, reflect: true})
  get selected() {
    return modelGetter(this, 'selected');
  }
  set selected(value: boolean) {
    const setter = propSetter(this, 'selected');
    setter({value, msg: Msg.select(value)});
  }

  onSelected(selected: boolean) {
    selected
      ? this.setAttribute('selected', 'true')
      : this.removeAttribute('selected');
  }

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_TAG]: FlyFloatingSurfaceItem;
  }
}
